import { render, staticRenderFns } from "./DaftarPelatihan.vue?vue&type=template&id=4c58c0ed&"
import script from "./DaftarPelatihan.vue?vue&type=script&lang=js&"
export * from "./DaftarPelatihan.vue?vue&type=script&lang=js&"
import style0 from "./DaftarPelatihan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports